import {COMMON_TOAST, COMMON_TOAST_RESET,} from './constants';

//
export const CommonToastReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case COMMON_TOAST_RESET:
            ret.showToast = false;
            ret.message = '';
            ret.errorMessage = '';
            ret.successMessage = '';
            ret.errorCode = 0;
            break;
        case COMMON_TOAST:
            ret.showToast = true;
            ret.message = data.message;
            ret.errorMessage = data.errorMessage;
            ret.successMessage = data.successMessage;
            ret.errorCode = data.errorCode;
            break;
        default:
            return {...state};
    }
    return ret;
}
